// Premium SVG-based score gauge — semicircle with gold needle
export default function ScoreGauge({ score = 0, size = 260 }) {
  const clamped = Math.max(0, Math.min(100, score));
  const radius = size / 2 - 16;
  const cx = size / 2;
  const cy = size / 2 + 12;
  const startAngle = 180;
  const endAngle = 360;
  const angle = startAngle + (clamped / 100) * (endAngle - startAngle);

  const polar = (a, r = radius) => {
    const rad = (a * Math.PI) / 180;
    return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)];
  };
  const arc = (a0, a1, r = radius) => {
    const [x0, y0] = polar(a0, r);
    const [x1, y1] = polar(a1, r);
    const large = a1 - a0 > 180 ? 1 : 0;
    return `M ${x0} ${y0} A ${r} ${r} 0 ${large} 1 ${x1} ${y1}`;
  };

  // Segments
  const segments = [
    { a0: 180, a1: 216, color: "#EF4444" }, // 0-20
    { a0: 216, a1: 252, color: "#F59E0B" }, // 20-40
    { a0: 252, a1: 288, color: "#D4AF37" }, // 40-60
    { a0: 288, a1: 324, color: "#10B981" }, // 60-80
    { a0: 324, a1: 360, color: "#10B981" }, // 80-100
  ];

  const tone = clamped >= 75 ? "#10B981" : clamped >= 50 ? "#F59E0B" : "#EF4444";

  return (
    <div className="text-center" data-testid="score-gauge">
      <svg width={size} height={size * 0.7 + 20} viewBox={`0 0 ${size} ${size * 0.7 + 20}`}>
        {/* Background track */}
        <path d={arc(180, 360)} stroke="#1E293B" strokeWidth="14" fill="none" strokeLinecap="butt" />
        {/* Colored segments (thin) */}
        {segments.map((s, i) => (
          <path key={i} d={arc(s.a0, s.a1)} stroke={s.color} strokeOpacity="0.35" strokeWidth="14" fill="none" />
        ))}
        {/* Active arc */}
        <path d={arc(180, angle)} stroke={tone} strokeWidth="14" fill="none" strokeLinecap="butt" />
        {/* Needle tip */}
        {(() => {
          const [nx, ny] = polar(angle, radius);
          return <circle cx={nx} cy={ny} r="6" fill="#D4AF37" stroke="#0F172A" strokeWidth="2" />;
        })()}
        {/* Center text — EFFICIENCY label sits inside the arc dome, score below it with clear separation */}
        <text x={cx} y={cy - 40} textAnchor="middle" fill="#CBD5E1" fontSize="11" fontFamily="Manrope" letterSpacing="3" fontWeight="600">EFFICIENCY</text>
        <text x={cx} y={cy + 20} textAnchor="middle" fill={tone} fontSize="56" fontFamily="Fraunces" fontWeight="500">{clamped}</text>
        <text x={cx} y={cy + 52} textAnchor="middle" fill="#94A3B8" fontSize="11" fontFamily="Manrope">/ 100</text>
      </svg>
    </div>
  );
}
